import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'kebabcase',
    standalone: false
})
export class KebabcasePipe implements PipeTransform {
  transform(value: string): string;
  transform(value: (string | number)[]): string;
  transform(value: unknown): string {
    if (typeof value === 'string') {
      return value.split(' ').join('-');
    } else if (Array.isArray(value)) {
      return value.join('-');
    } else {
      console.warn(
        'kebabCase pipe received value of type ' +
          typeof value +
          ' but expected string or (string | number)[]'
      );
      return '';
    }
  }
}
